import { Exclude } from 'class-transformer';
import { IsBoolean, IsNotEmpty, IsOptional, IsString } from 'class-validator';
import { BaseCreateDto, BaseDto, BaseUpdateDto } from '../base.dto';
import { TrainingConditionDifficultyLevelDto } from './training-condition-difficulty-level.dtos';

export interface TrainingConditionDifficultyLevelGroupingDto extends BaseDto {
  name: string;
  defaultDifficultyLevelGroup?: boolean;
  trainingConditionDifficultyLevels?: TrainingConditionDifficultyLevelDto[];
  notes?: string;
}

export class CreateTrainingConditionDifficultyLevelGroupingDto
  extends BaseCreateDto
  implements Partial<TrainingConditionDifficultyLevelGroupingDto>
{
  @IsString()
  @IsNotEmpty()
  name: string;

  @IsBoolean()
  defaultDifficultyLevelGroup: boolean;

  @Exclude()
  trainingConditionDifficultyLevels?: never;

  @IsOptional()
  @IsString()
  notes?: string;
}

export class UpdateTrainingConditionDifficultyLevelGroupingDto
  extends BaseUpdateDto
  implements Partial<TrainingConditionDifficultyLevelGroupingDto>
{
  @IsOptional()
  @IsString()
  @IsNotEmpty()
  name?: string;

  @IsOptional()
  @IsBoolean()
  defaultDifficultyLevelGroup?: boolean;

  @Exclude()
  trainingConditionDifficultyLevels?: never;

  @IsOptional()
  @IsString()
  notes?: string;
}
